module.exports = __webpack_public_path__ + "img/forklift.75166cd5.svg";